import gql from 'graphql-tag';

export default (requestId, provider, name, email, photoUrl) => gql`
    mutation AddSocialProvider {
      addSocialProvider (
        requestId: "${requestId}",
        provider: "${provider}",
        name: "${name}",
        email: "${email}",
        photoUrl: "${photoUrl}"
      ) {
        id,
        requestId,
        provider,
        name,
        email,
        photoUrl,
        createdAt
      }
    }
  `;
